(() => {
  try {
      const globalHelpline = document.getElementById("globalHelpline");
      const globalResource = document.querySelector(".globalResource");
      const fraudResourceLinks = document.querySelectorAll(".resource-link");
      const reportEle = document.querySelector(".report_link");
      const reportLinks = document.querySelectorAll(".reportLink");

      const setReportLink = (reportLink, country, language) => {
        const rUrl = new URL(reportLink);
        rUrl.searchParams.set("WUCountry", country);
        rUrl.searchParams.set("WULanguage", language);
        reportLink.href = rUrl.href;
        return reportLink.href;
      };

      if (globalHelpline) {
        const cList = globalHelpline.querySelector("#globalCountries");
        const cFooter = globalHelpline.querySelector(
          "#footer-country-dropdown"
        );
        const cSelect = globalHelpline.querySelector(".countries");

        let countryCode = CookieService.getCookie("AKCountry") || "US";

        const countryName = globalHelpline.querySelector("#countryName");
        const helpNo = globalHelpline.querySelector("#helpNo");
        const countriesObj =
          globalHelpline.querySelector("#helpline_numbers");
        const helpline_nos =
          countriesObj &&
          countriesObj.innerHTML &&
          JSON.parse(countriesObj.innerHTML);

        const fetchLanguage = (language = "en") => {
          if (language?.length !== 2) {
            let codes = language.split("-");
            language = helpline_nos?.[codes[0]] ? codes[0] : codes[1];
          }
          return language;
        };
        const language = fetchLanguage(pageData.language);

        const setLink = (element, url, country, language) => {
          element.href = `/${country}/${language}${url}`;
        };

        const setLanguage = (country, language, helpline_nos) => {
          return helpline_nos?.[country]?.["languages"]?.includes(language)
            ? language
            : "en";
        };

        cSelect.onchange = function () {
          const cIndex = cSelect.selectedIndex;
          countryName.innerText =
            cSelect.children[cIndex].text || countryCode;
        };

        countryCode = countryCode.toLowerCase();
        cFooter.setAttribute("data-country", countryCode);
        cFooter.setAttribute("data-selected", countryCode);
        let setLang = language;
        cFooter.setAttribute("data-language", setLang);
        helpNo.innerHTML = helpline_nos?.[countryCode]?.["phone"];

        const setAllFraudLinks = (countryCode, setLang) => {
          reportLinks?.forEach((ele) => {
            setReportLink(ele, countryCode, setLang);
          });
          fraudResourceLinks?.forEach((ele) => {
            const url = ele.href;
            const phone = helpline_nos[countryCode]?.["phone"] || "";
            let rUrl = new URL(url);
            rUrl.searchParams.set("country", countryCode);
            rUrl.searchParams.set("language", setLang);
            if (phone) {
              rUrl.searchParams.set("call", phone);
            } else {
              rUrl.searchParams.delete("call");
            }
            ele.href = rUrl.href;
          });
        };
        setAllFraudLinks(countryCode, setLang);

        cList?.addEventListener("click", function (e) {
          countryCode = e.target
            .closest("li")
            .getAttribute("data-flag-select-value");
          if (helpline_nos[countryCode]) {
            setLang = language;

            countryName.innerText = e.target
              .closest("li")
              .getAttribute("data-flag-select-text");
          }
          setAllFraudLinks(countryCode, setLang);
          if (helpline_nos?.[countryCode]?.["phone"]) {
            helpNo?.parentElement?.classList.remove("d-none");
            helpNo.innerHTML = helpline_nos[countryCode]?.["phone"];
          } else {
            helpNo?.parentElement?.classList.add("d-none");
          }
        });
      }
      if (globalResource) {
        const thirdPartyBlock = document.querySelector(
          ".third-party-resources"
        );
        let country =
          getURLParameter("country") ||
          CookieService.getCookie("AKCountry") ||
          "US";
        let language = getURLParameter("language") || pageData.language;
        if (language?.length!== 2) {
          language = (language=='ca-fr') ? 'fr' : language.split("-")[0];
        }
        const enableCountry = thirdPartyBlock?.querySelector(
          "." + country + "-block"
        );
        if (enableCountry) {
          thirdPartyBlock?.classList?.remove("d-none");
          enableCountry?.classList?.remove("d-none");
        }

        const helpContainer = document.querySelector(".helpContainer");
        const reportUrl = setReportLink(reportEle, country, language) || "";
        const phoneObj =
          globalResource?.querySelector("#helpline_numbers");
        const helpline_list =
          phoneObj &&
          phoneObj.innerHTML &&
          JSON.parse(phoneObj.innerHTML);
        const phone = getURLParameter("call") || helpline_list?.[country.toLowerCase()];
        let helpText = phone ? helpContainer.getAttribute("data-help") : "";

        let links = document.querySelectorAll("a");
        links.forEach((link) => {
          const url = decodeURIComponent(link.getAttribute("href"));
          if (url == "{{report_link}}") {
            link.setAttribute("href", reportUrl);
          }
          if (url == "{{helpline_no}}") {
            if(window.innerWidth <= 1024){
              link.setAttribute("href", "tel:" + phone?.trim());
            } else {
              link.setAttribute("href", "/global-service/report-fraud-hotline");
            }
          }
        });
        globalResource.innerHTML = globalResource.innerHTML.replace(
          "{{help_text}}",
          helpText
        );
        globalResource.innerHTML = globalResource.innerHTML.replace(
          "{{helpline_no}}",
          phone
        );
      }
      if(globalHelpline || globalResource) {
        //Add Logo URL redirection 
        const wuCountry = CookieService.getCookie('WUCountryCookie_') || CookieService.getCookie('AKCountry')
        const wuLanguage = CookieService.getCookie('WULanguageCookie_') || 'en'
        const logoElements = document.querySelectorAll('.wu-logo')
        Array.from(logoElements).forEach((logoElement)=>{
          logoElement.href= wuCountry ? logoElement.href.replace('/us/en','/'+wuCountry.toLowerCase()+'/'+wuLanguage.toLowerCase()) : logoElement.href
        })
      }
  } catch(e) {
      console.log(e)
  }
  
})();